<template>
    <CCard v-if="!item.ad" :style="{'background-color': backgroundColor}">
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img :src="item.type_vehicle.logo" width="150" />
                </div>
                <div class="col-sm-6">
                    <label class="label">
                        {{item.name_vehicle}}
                    </label>
                    <CRow>
                        <div class="col-sm-3">
                            <label class="label">
                                De:
                            </label>
                        </div>
                        <div class="col-sm-9">
                            <label class="label">
                                {{item.origin_state.name}}
                            </label>
                        </div>
                    </CRow>
                    <CRow>
                        <div class="col-sm-3">
                            <label class="label">
                                Hacia:
                            </label>
                        </div>
                        <div class="col-sm-9">
                            <label class="label">
                                {{item.destination_state.name}}
                            </label>
                        </div>
                    </CRow>
                </div>
                <div v-if="item.is_demo" class="col-sm-2" style="text-align: center">
                    <img src="@/assets/images/ic_star.png" width="60" />
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('charges.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
    <CCard v-else>
        <CCardBody>
            <a :href="item.advertisement.url"  target="_blank">
                <img :src="item.advertisement.path" style="height: 100%; width: 100%; object-fit: cover;"/>
            </a>
        </CCardBody>
    </CCard>
</template>

<script>
import store from '../../../store'

export default {
    name: "ChargeItem",
    props: ['item'],
    data() {
        return {
            configuration: null,
        }
    },
    computed: {
        backgroundColor() {
            let self = this;

            if (self.item.is_demo && store.state.configuration != null 
                && store.state.configuration.configuration.color_activas != null) {
                return "#"+store.state.configuration.configuration.color_activas;
            } else {
                return self.item.type_vehicle.color;
            }
        }
    },
    methods: {
        onShowItem() {
            this.$emit('onShowItem', this.item);
        },
    },
}
</script>
